(function (window) {
  function init() {
    const countrySelector = document.querySelector('.js-country-selector:not([data-country-selector-init="true"])');
    // If there is no country selector on the page, do nothing.
    if (!countrySelector) return;
    const map = countrySelector.querySelector('.js-country-selector-map');
    // If there is no map in the country selector, do nothing.
    if (!map) return;
    const tabs = countrySelector.querySelectorAll('.js-country-selector-tab-button, .js-accordion-tabs-accordion-control');
    tabs.forEach(tab => tab.addEventListener('click', changeMap));

    /**
     * Change map source using data-map attribute from region selected.
     */
    function changeMap(e) {
      map.style.backgroundImage = "url('" + this.getAttribute('data-map') + "')";
    }
  }

  // Instantiate map image switch behavior immediately.
  init();
  // Instantiate map image switch behavior on component-init.
  window.componentEvents.on('component-init', init);
})(window);
